import load from 'little-loader';

export default () => {
    const url = 'https://sdk.pulse.schibsted.com/gdpr-transparency-apnxs/latest/gdpr-bundle.js';

    return new Promise((resolve, reject) => {
        load(url, (err) => {
            if (err) {
                return reject(err);
            }

            return resolve();
        });
    });
};



/** WEBPACK FOOTER **
 ** ./src/ads/load-cogwheel.js
 **/